import { render } from "./StepsVertical.vue?vue&type=template&id=e59f7128"
import script from "./StepsVertical.vue?vue&type=script&lang=ts"
export * from "./StepsVertical.vue?vue&type=script&lang=ts"
script.render = render

export default script